import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderLock, FileText, Search, Clock } from 'lucide-react';

/**
 * ContinueWorkSection — appears ONLY when the user has actual saved
 * work: an open Case Locker case, a grievance draft, or a Fact Finder.
 * Hides itself when there's nothing to resume — no fake data.
 */

function timeAgo(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60)    return 'just now';
    if (s < 3600)  return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  } catch { return ''; }
}

const ITEM_ICONS = {
  case:      FolderLock,
  grievance: FileText,
  factFinder: Search,
};

export default function ContinueWorkSection({ items }) {
  const navigate = useNavigate();
  if (!items || items.length === 0) return null;

  return (
    <section aria-labelledby="cc-continue-title" data-testid="cc-continue-work">
      <header className="cc-section-head">
        <div className="cc-section-eyebrow">In Progress</div>
        <h2 id="cc-continue-title" className="cc-section-title">Continue where you left off</h2>
        <span className="cc-section-title-underline" aria-hidden="true" />
      </header>
      <div className="cc-continue">
        {items.map((item) => {
          const Icon = ITEM_ICONS[item.type] || Clock;
          return (
            <button
              key={item.id}
              type="button"
              className="cc-continue-item"
              onClick={() => navigate(item.route)}
              data-testid={`cc-continue-item-${item.id}`}
            >
              <span className="cc-continue-icon" aria-hidden="true">
                <Icon size={16} strokeWidth={2.3} />
              </span>
              <span className="cc-continue-body">
                <span className="cc-continue-title">{item.title}</span>
                <span className="cc-continue-meta">
                  {item.status ? `${item.status} · ` : ''}Updated {timeAgo(item.updatedAt)}
                </span>
              </span>
              <span className="cc-continue-btn">Continue</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
